import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGlobalPpsisNir } from '../actions';
import { getGlobalPublishedPppsisNir, getIsFetching } from '../selectors';

const useGlobalPublishedPpsisNir = (status, toLocalLanguage) => {
  const dispatch = useDispatch();
  const isFetching = useSelector(getIsFetching);
  const globalPublishedPpsis = useSelector(getGlobalPublishedPppsisNir);

  useEffect(() => {
    dispatch(fetchGlobalPpsisNir(status, toLocalLanguage));
  }, [dispatch, status, toLocalLanguage]);

  return [isFetching, globalPublishedPpsis];
};

export default useGlobalPublishedPpsisNir;
